import enumBase from './EnumBase';

export default class BackupState extends enumBase {
  static CREATED = 'created';
  static PROCESSING = 'processing';
  static FAILED = 'failed';
  static COMPLETED = 'completed';
  static FINISHED = 'finished';
  static EXPIRED = 'expired';

  static values = [
    this.CREATED,
    this.PROCESSING,
    this.FAILED,
    this.COMPLETED,
    this.FINISHED,
    this.EXPIRED,
  ];

  static getText(value, i18n) {
    return i18n.t(`signaturesList.backupState.${value}`) || value;
  }
}
